import { render, staticRenderFns } from "./table-data-3.vue?vue&type=template&id=343fb6e8&scoped=true"
import script from "./table-data-3.vue?vue&type=script&lang=js"
export * from "./table-data-3.vue?vue&type=script&lang=js"
import style0 from "./table-data-3.vue?vue&type=style&index=0&id=343fb6e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343fb6e8",
  null
  
)

export default component.exports